import { render, staticRenderFns } from "./estate-side-pane.vue?vue&type=template&id=481f3661&scoped=true&"
import script from "./estate-side-pane.vue?vue&type=script&lang=js&"
export * from "./estate-side-pane.vue?vue&type=script&lang=js&"
import style0 from "./estate-side-pane.vue?vue&type=style&index=0&id=481f3661&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f3661",
  null
  
)

export default component.exports